import { postRequest } from "../lib/utils/request";

export const registerAPI = async (apiHost, data, requestOptions) => {
  return await postRequest(
    `${apiHost}/v1/notifications/${data.token}/register`,
    data,
    requestOptions
  );
};



/** WEBPACK FOOTER **
 ** ./src/common/notification/api.js
 **/